"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _baseStyles = _interopRequireDefault(require("./baseStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = Object.assign({}, _baseStyles["default"], {
  handleStyle: {
    backgroundColor: 'black',
    borderColor: 'black',
    height: '11px',
    width: '11px',
    zIndex: 1
  }
});
var _default = styles;
exports["default"] = _default;